import moment from 'moment';

const BlackoutPeriodListColumn = [
  {
    title: 'Webpage URL',
    dataIndex: 'urls',
    slot: 'urls',
    width: 250
  },
  {
    title: 'Start Date/Time',
    dataIndex: 'start',
    slot: 'start',
    sorter: (a, b) => moment(a.start).diff(moment(b.start)),
    width: 200
  },
  {
    title: 'End Date/Time',
    dataIndex: 'end',
    slot: 'end',
    sorter: (a, b) => moment(a.end).diff(moment(b.end)),
    width: 200
  },
  {
    title: 'Status',
    dataIndex: 'status',
    slot: 'status',
    sorter: (a, b) => a.status.length - b.status.length,
    width: 200
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];
export { BlackoutPeriodListColumn };
